import { withData } from './base-composer';

/**
 * Availability composer function
 * @param state
 */
export const Contact = state => {
  return Object.assign(
    {},
    state,
    // composers
    withData()
  );
};
